import { createIcon } from '../utils';

export const MoonIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.7 14.5474C19.3866 15.1413 17.9286 15.472 16.3934 15.472C10.6152 15.472 5.93111 10.7878 5.93111 5.00966C5.93111 3.47448 6.26176 2.01652 6.85572 0.703125C3.22571 2.34476 0.699951 5.99782 0.699951 10.2408C0.699951 16.019 5.38409 20.7031 11.1623 20.7031C15.4053 20.7031 19.0583 18.1774 20.7 14.5474Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'MoonIcon',
  },
);
